<div
  (click)="imageClick(0)"
  class="innerBanner"
  [style.background-image]="
    aboutUsDetails.bannerImage
      ? 'url(' + aboutUsDetails.bannerImage + ')'
      : 'url(' + '../../../assets/images/NoImage.jpg' + ')'
  "
>
  <!-- <img
    [src]="aboutUsDetails.bannerImage ? aboutUsDetails.bannerImage : '../../../assets/images/NoImage.jpg'"
    style="width: 100%"
  /> -->
  <div class="bannerText"></div>
</div>
<!-- <nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a href="/home">Home</a></li>
    <li class="breadcrumb-item active" aria-current="page">{{ aboutUsDetails.bannerTitle }}</li>
  </ol>
</nav> -->

<p-galleria
  [(value)]="images"
  [(visible)]="displayCustom"
  [(activeIndex)]="activeIndex"
  [fullScreen]="true"
  [showItemNavigators]="false"
  [baseZIndex]="100000"
  [containerStyle]="{ 'max-width': '90%' }"
>
  <ng-template pTemplate="item" let-item>
    <img [src]="item" class="gallery-image" />
  </ng-template>
  <!-- <ng-template pTemplate="thumbnail" let-item>
    <div class="grid grid-nogutter justify-content-center">
      <img [src]="highLights.bannerImage" style="display: block" />
    </div>
  </ng-template> -->
</p-galleria>
<div class="container contentPanel">
  <!-- <app-breadcrumb></app-breadcrumb> -->
  <app-breadcrumb-row></app-breadcrumb-row>
  <h1>{{ aboutUsDetails.bannerTitle }}</h1>
  <div class="contentPanel">
    <p [innerHTML]="aboutUsDetails.content"></p>
    <p>&nbsp;</p>
  </div>
  <div *ngIf="culture">
    <div class="highlightSection">
      <div class="popular-items">
        <p-carousel
          [value]="cultureDetailsList"
          styleClass="custom-carousel"
          [numVisible]="3"
          [numScroll]="1"
          [circular]="true"
          class="islands-carousel"
          [responsiveOptions]="responsiveOptions"
        >
          <ng-template let-product pTemplate="item">
            <div class="product-item slider-arrow">
              <a (click)="getDetails(product.title)">
                <div class="product-item-content">
                  <div class="image">
                    <img src="{{ product.bannerImage }}" [alt]="product.title" class="product-image slider-image" />
                  </div>
                </div>
              </a>
            </div>
            <div class="title">
              <h3>{{ product.bannerTitle }}</h3>
            </div>
          </ng-template>
        </p-carousel>
      </div>
    </div>
  </div>
  <div *ngIf="society">
    <div class="highlightSection">
      <div class="popular-items">
        <p-carousel
          [value]="societyDetailsList"
          styleClass="custom-carousel"
          [numVisible]="3"
          [numScroll]="1"
          [circular]="true"
          class="islands-carousel"
          [responsiveOptions]="responsiveOptions"
        >
          <ng-template let-product pTemplate="item">
            <div class="product-item slider-arrow">
              <a (click)="getDetails(product.title)">
                <div class="product-item-content">
                  <div class="image">
                    <img src="{{ product.bannerImage }}" [alt]="product.title" class="product-image slider-image" />
                  </div>
                </div>
              </a>
            </div>
            <div class="title">
              <h3>{{ product.bannerTitle }}</h3>
            </div>
          </ng-template>
        </p-carousel>
      </div>
    </div>
  </div>
</div>
